import type { IMenuRoute } from "@/models/routes";
import i18n from "@/i18n";

export function ticketsTabigation(): (IMenuRoute & { exact?: boolean })[] {
  return [
    {
      label: i18n.t("_.active_tickets"),
      to: { name: "admin__clientActiveSupportTickets" }
    },
    {
      label: i18n.t("_.closed_tickets"),
      to: {
        name: "admin__clientClosedSupportTickets"
      }
    }
  ];
}
